// extracted by mini-css-extract-plugin
export default {"overviewAndMapSection":"Xso40Y","overviewPanel":"Mc_aJB"};